import { useTranslation } from 'react-i18next'
import { QuickGlanceOverlay } from '@fs/zion-ui'
import React from 'react'
import LabelAndData from '../../common/LabelAndData'
import { UserLink } from '../../app/Links'
import { timestampToDateString } from '../../../util/DateUtil'

export default function TreeChangesMoreMetadataDialog({ metadata, _idsMetadata, ...overlay }) {
  const { t } = useTranslation()
  return (
    <QuickGlanceOverlay {...overlay}>
      {metadata && (
        <>
          {metadata.entityRefId && (
            <LabelAndData label={t('person.overlay.entityRefId', 'Entity Ref ID')} displayData={metadata.entityRefId} />
          )}
          {metadata.value && (
            <>
              {metadata.value.type && (
                <LabelAndData label={t('person.overlay.valueType', 'Value Type')} displayData={metadata.value.type} />
              )}
              {metadata.value.uri && (
                <LabelAndData label={t('person.overlay.valueUri', 'Value URI')} displayData={metadata.value.uri} />
              )}
            </>
          )}
          {metadata.originallyAttachedTo && (
            <LabelAndData
              label={t('person.overlay.originallyAttachedTo', 'Originally Attached To')}
              displayData={metadata.originallyAttachedTo}
            />
          )}
          {metadata.attribution && (
            <>
              {metadata.attribution.modified && (
                <LabelAndData
                  label={t('person.overlay.modified', 'Modified')}
                  displayData={timestampToDateString({
                    timestamp: Number(metadata.attribution.modified),
                    withTime: true,
                  })}
                />
              )}
              {metadata.attribution.modifiedDateNormalized?.map((date) => (
                <div key={date.value}>
                  <LabelAndData
                    label={t('person.overlay.modifiedDateNormalized', 'Modified Date Normalized')}
                    displayData={date.value}
                  />
                </div>
              ))}
              {metadata.attribution.contributor && (
                <LabelAndData
                  label={t('person.overlay.contributor', 'Contributor')}
                  displayData={<UserLink userId={metadata.attribution.contributor.id} />}
                />
              )}
              {metadata.attribution.submitter && (
                <LabelAndData
                  label={t('person.overlay.submitter', 'Submitter')}
                  displayData={metadata.attribution.submitter.id}
                />
              )}
              {metadata.attribution.agentApp && (
                <LabelAndData
                  label={t('person.overlay.agentApp', 'Agent App')}
                  displayData={metadata.attribution.agentApp}
                />
              )}
            </>
          )}
          {metadata.commandUuid && (
            <LabelAndData label={t('person.overlay.commandUuid', 'Command UUID')} displayData={metadata.commandUuid} />
          )}
        </>
      )}
    </QuickGlanceOverlay>
  )
}
